import { useParams } from 'react-router-dom';
import { SpecimensPage } from './SpecimensPage';

export const SpecimensPageWithPatient = (): JSX.Element => {
  const { patientId } = useParams<{ patientId: string }>();

  return <SpecimensPage patientId={patientId} />;

};
